import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { SignIn } from './components/SignIn';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    {/*
      Outside App on purpose: App bootstraps by calling the API, and hosted that
      call needs a token it cannot have yet. The gate resolves who you are first,
      then App mounts and behaves exactly as it does locally.
    */}
    <SignIn>
      <App />
    </SignIn>
  </StrictMode>,
);
